var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44749 5.49992C6.71698 3.49718 8.7184 1.83325 11 1.83325C13.2817 1.83325 15.2831 3.49718 15.5526 5.49992H18.1931C19.2056 5.49992 20.0264 6.32073 20.0264 7.33325C20.0264 7.42 20.0203 7.50665 20.008 7.59252L18.4366 18.5925C18.3076 19.4957 17.534 20.1666 16.6217 20.1666H5.37838C4.46603 20.1666 3.6925 19.4957 3.56348 18.5925L1.99205 7.59252C1.84886 6.59018 2.54534 5.66154 3.54768 5.51834C3.63356 5.50608 3.7202 5.49992 3.80696 5.49992H6.44749ZM13.6839 5.49992C13.4053 4.52649 12.2816 3.66659 11 3.66659C9.7185 3.66659 8.5948 4.52649 8.31614 5.49992H13.6839ZM3.80696 7.33325H6.4167V9.16658H8.25003V7.33325H13.75V9.16658H15.5834V7.33325H18.1931L16.6217 18.3333H5.37838L3.80696 7.33325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.c7dff46124de84988dc4edf39c4b2b08.svg";
export { ForwardRef as ReactComponent };